import {useEffect} from 'react';
import {initPanel, removePanel} from '@Components/panel/panel-reducer';
import {useAppDispatch} from '@/hooks';

/**
 * Registers a panel id in the panel registry for the lifetime of the component — but only when no
 * other component holds it. Hosts often swap child panels in under their own panel id (the add-items
 * sheet, the uploads modal); without this ownership rule the child's unmount would deregister the
 * still-mounted host, and every later close on that id would throw "Panel not initialized".
 */
const usePanelRegistration = (panelId: string, hideOnClose = false): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const isRegisteredByAnotherComponent = window.PMW.redux.store.getState().panels.panelHashmap[panelId] !== undefined;
    if (isRegisteredByAnotherComponent) {
      return undefined;
    }
    dispatch(initPanel({id: panelId, hideOnClose}));
    return (): void => {
      dispatch(removePanel(panelId));
    };
  }, [panelId]);
};

export default usePanelRegistration;
